import { render, staticRenderFns } from "./RecommendedTalkTextFeatureAdditions.vue?vue&type=template&id=59bdbb10&"
import script from "./RecommendedTalkTextFeatureAdditions.vue?vue&type=script&lang=js&"
export * from "./RecommendedTalkTextFeatureAdditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports